module.exports = __webpack_public_path__ + "img/cultureClose5.5987857d.png";